//不要格式化
export default {
  home: {
    Login: '登 錄', // 登录
    Sign: '註 冊', // 立即注册
    Slogan: '分享每一刻 收穫每一刻', //分享每一刻 收获每一刻
    ImmedSign: '立即註冊', // 立即注册
    Enter: '進入CloudMaster', // 进入CloudMaster
    Signup: '註冊FEEMOO賬號', // 注册飞猫盘账号
    Simple: '超簡單極速註冊', // 超简单极速注册
    Master: '開通CloudMaster', // 开通飞猫达人
    Exclusive: '達人專屬標識/權益', //达人专属标识/权益
    ShareFile: '分享文件賺收益', // 分享文件赚收益
    Others: '他人下載/轉存即獲得收益', // 他人下载/转存即获得收益
    Advantages: '平臺優勢', // 平台优势
    Multiple: '多種模式靈活玩法多樣', //多种模式灵活玩法多样
    CardTitle1: 'FEEMOO返利', // FEEMOO返利
    CardText1: 'FEEMOO是分享型網盤，成爲達人後上傳文件，生成分享鏈接供他人下載。', // 
    CardText1_2prefix: '可選擇', //可选择
    CardText1_2Blod: '下載量返利模式', //下载量返利模式
    CardText1_2suffix: '，區分大小文件按下載量返利，區分等級萬次下載最高1888元，每週三、週四雙倍收益。', //，区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益。
    CardText1_3prefix: '或選擇', //或选择
    CardText1_3Blod: '會員返利模式', //会员返利模式
    CardText1_3suffix: '，不按下載次數計費，只根據下載用戶開通會員進行按比例分成，文件不過期，頁面更簡潔。', //，不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁。
    CardTitle2: '優惠碼返利', // 优惠码返利
    CardText2: '使用專屬您的邀請碼邀請用戶開通FEEMOO會員，您可獲得返利收益。', // 使用专属您的邀请码邀请用户开通飞猫盘会员，您可获得返利收益
    CardTitle3: '下線返利', // 下线返利
    CardText3: '好友通過邀請鏈接註冊FEEMOO賬號後申請成爲CloudMaster，您可獲得好友收益的分成返利。', // 好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的分成返利。
    Income: '真實收益', // 真实收益
    Random: '隨機展示上週部分收益提現記錄 真實提現看得到', // 随机展示上周部分收益提现记录 真实提现看得到
    Feedback: '真實用戶反饋', // 真实用户反馈
    Realization: '上線十年流量變現平臺，真實反饋', // 上线十年流量变现平台，真实反馈
    Enjoy: '享受分享的樂趣，輕鬆賺取屬於你的變現收益', // 享受分享的乐趣，轻松赚取属于你的变现收益。
  },
  nav: { //头部模块
    Login: '登 錄', //登录
    Sign: '註 冊', //注册
    Account: '個人賬戶', //个人账户
    SignOut: '退出', //退出
  },
  GradeColor: { //等级颜色
    Bronze:'青銅',//青铜
    Silver:'白銀',//白银
    Gold:'黃金',//黄金
    Diamond:'鑽石',//钻石
    Master:'大師',//大师
    King:'王者',//王者
  },
  IntrDaren: { //未登录展示
    FeeMooMaster: '飛貓達人', //飞猫达人
    TextOne: '開通成爲飛貓達人後即可解鎖多項推廣返利功能！', //开通成为飞猫达人后即可解锁多项推广返利功能！
    OpenVIP: '立即開通', //立即开通
    PlatformPlay: '平臺玩法', //平台玩法
    PlateRebate: '飛貓盤返利', //飞猫盘返利
    TextFive: '分享文件給其他用戶下載/轉存獲得收益', //分享文件给其他用户下载/转存获得收益
    PromoCodeRebate: '優惠碼返利', //优惠码返利
    TextSix: '用戶通過優惠碼開通會員獲得返利收益', //用户通过优惠码开通会员获得返利收益
    DownlineRebate: '下線返利', //下线返利
    TextSeven: '邀請好友成爲飛貓達人獲得好友的收益分成', //邀请好友成为飞猫达人获得好友的收益分成
    ActivityRule: '活動規則', //活动规则
    TextTwo: '申請人需完善收款人信息', //申请人需完善收款人信息
    TextThree: '需要遵守平臺規則', //需遵守平台规则
    TextFour: '《飛貓盤用戶服務協議》', //《飞猫盘用户服务协议》
  },
  FmCloud: { //飞猫盘模块
    DownloadRebateMode: '下載量返利模式', //下载量返利模式
    YouHave: '您有', //您有
    FilesUsingMode: '個文件使用該模式', //个文件使用该模式
    MyGrade: '我的等級：', //我的等级：
    TextOne:
      '區分大小文件按下載量返利，區分等級萬次下載最高1888元，每週三、週四雙倍收益', //区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益
    DetailedIntroduction: '詳細介紹', //详细介绍
    LargeFileIncome: '大文件收益', //大文件收益
    SmallFileIncome: '小文件收益', //小文件收益
    TextTwo: '今日大於100M文件下載量（次）', //今日大于100M文件下载量（次）
    TextThree: '今日小於100M文件下載量（次）', //今日小于100M文件下载量（次）
    WeekAward: '每週飛貓達人獎', //每周飞猫达人奖
    TextFour: '次日上午8點自動兌換到餘額', //次日上午8点自动兑换到余额
    NotYetAwarded: '暫未獲獎', //暂未获奖
    ReceiveReward: '領取獎勵', //领取奖励
    Claimed: '已領取', //已领取
    MemberRebateModel: '會員返利模式', //会员返利模式
    TextFive: '每週三評獎', //每周三评奖
    TextSix:
      '不按下載次數計費，只根據下載用戶開通會員進行按比例分成，文件不過期，頁面更簡潔', //不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁
    RebateVIP: '返傭個數', //返佣个数
    CommissionRebate: '返佣金額', //返佣金额
    VIPRebatesToday: '今日返傭個數', //今日返佣个数
    CommissionBackToday: '今日返佣金額', //今日返佣个数
  },
  NavLeft: { //左侧菜单模块
    FEEMOO:'Feemoo',//飞猫盘
    Fm2shortlink: 'Fm2短鏈', // Fm2短链
    PromotionCode:'優惠碼',//优惠码
    DownlineRebate:'下線返利',//下线返利
    HelpCenter:'幫助中心',//帮助中心
    BalanceWithdrawal:'餘額提現',//余额提现
    AccountManagement:'賬號管理',//账号管理
  },
  Fm2shortlinkbate: {
    Fm2link: 'Fm2短鏈', //Fm2短链
    dataDetails: '數據明細', //数据明细
    Fm2ShortLink: '什麼係Fm2短鏈？', // 什么是Fm2短链？
    LinkisaFast: 'Fm2短鏈係一款高效、安全嘅網址壓縮工具，專為中文互聯網場景而設。只要按一鍵，就可以將冗長嘅原始連結縮短成「fm2.cc/d/」嘅極簡格式，支援批量新建；亦支援多種分享模式，與CloudMaster全系產品疊加，一份流量，享多重收益。',
    CreatetoShorten: '新建短鏈',
    CreatetoShorten2: '輸入需要縮短嘅地址',
    clickyourlin: "分享短鏈",
    clickyourlin2: "其他人瀏覽你嘅短鏈",
    Earnmore: "獲得收益",
    Earnmore2: "解鎖越多收益越多",
    Fm2Earnings: 'Fm2短鏈收益',
    Multiplemodels: '多種分享模式任你揀',
    Directjump1: '免登錄無條件解鎖：',
    Directjump2: '用戶零操作直接解鎖，',
    Directjump3: '元/萬次',
    Directjump4: '（門檻最低，適合快速引流）',
    Loginjump1: '登錄後無條件解鎖：',
    Loginjump2: '用戶需先登入賬號，無需額外操作，',
    Loginjump3: '元/萬次',
    Loginjump4: '（收益提升，需登入授權）',
    Miniadjump1: '去小程序睇廣告後解鎖：',
    Miniadjump2: '用戶需掃碼入小程序觀看廣告，完成後獲取鏈接解鎖，',
    Miniadjump3: '元/萬次',
    Miniadjump4: '（廣告互動，收益翻倍）',
    Feemooadjump1: '去APP睇廣告後解鎖：',
    Feemooadjump2: '用戶需透過Feemoo APP掃碼觀看廣告，完成後獲取鏈接解鎖，',
    Feemooadjump3: '元/萬次',
    Feemooadjump4: '（最高收益，需經Feemoo APP參與）',
    Extrareferralbonus1: '多重收益：',
    Extrareferralbonus2: '其他用戶經你嘅Fm2短鏈註冊Feemoo賬號後，你仲可獲得引薦計劃-Feemoo下線用戶獎勵',
    Extrareferralbonus3: '（前往了解）',
    DataOverview: '數據概覽', //数据概览
    DataOverview2: '每日上午8點更新',
    ViewDetails: '點擊查看數據明細', //查看详情
    YesterdayViews: '昨日瀏覽量',
    YesterdayRedirects: '昨日解鎖量',
    YesterdayEarnings: '昨日收益金額',
    Yesterday: '昨日用戶透過短鏈接解鎖成功嘅有效次數',
    RevenueExplanation: '收益說明',
    Shortearnings: '短鏈收益：',
    payoutdepends: '收益金額取決於該短鏈設定嘅收益模式，具體金額以頁面展示為準。',
    Shortearningtitle: '多重收益：',
    Multiearnings: '其他用戶經你嘅Fm2短鏈註冊Feemoo賬號即成為你嘅下線，符合條件即可額外獲得三重獎勵，與短鏈收益並行計算，互不衝突。',
    Invalidtraffic: '無效流量：',
    emulators: '任何腳本、模擬器、群控、VPN代理或其他刷量方式產生嘅點擊，均視為無效，不計收益。',
    Rateadjustments: '調價說明：',
    thirdparty: '若第三方廣告平台延遲結算、扣量或拒付，Feemoo將按同比例下調收益，並於平台公告原因及調整幅度。',
    Violationpolicy: '違規處理：',
    original: '如原始鏈接被投訴或審核認定為違法、違規、低俗、侵權、欺詐、釣魚、色情、暴力、賭博、涉政敏感等，Feemoo將立即鎖定該短鏈並清零收益。如有異議，可於幫助中心申訴。',
    RevenueModel: '分享模式', //分享模式
    UserSteps: '訪問用戶操作步驟',
    Earningsper: '解鎖量收益（元/萬次）',
    MultiEarnings: '多重收益',
    NoLoginJump: '免登錄無條件解鎖',
    Clicklogin: '免登錄，按鈕即解鎖',
    None: '無',
    LoginJumps: '登錄後無條件解鎖',
    Loginredirect: '先登錄，點擊按鈕直接解鎖',
    Registervia: '經短鏈註冊賬號，成為下線用戶',
    Miniprogram: '去小程序睇廣告後解鎖',
    WeChatQR: '先登錄，微信掃碼睇廣告後自動解鎖',
    Appadjump: '去APP睇廣告後解鎖',
    FeemooQR: '先登錄，APP掃碼睇廣告後自動解鎖',
    Earnings: '收益金額',
    Redirectst: '瀏覽/解鎖量',
    ViewsViews: '瀏覽量',
    ViewsViewss: '解鎖量',
    Directjump11: '免登錄無條件解鎖',
    Loginjump11: '登錄後無條件解鎖',
    Miniadjump11: '去小程序睇廣告後解鎖',
    Feemooadjump11: '去APP睇廣告後解鎖',
  },
  MemberRebate: { //优惠码模块
    RebateCode:'返利優惠碼',//返利优惠码
    IncomeData:'收益數據',//收益数据
    //返利优惠码模块
    rebateDisCode:{
      YourCurrentLevel:'您當前等級：',//您当前等级：
      Levels:'等級介紹',//等级介绍
      CouponCodeDiscount:'優惠碼折扣',//优惠码折扣
      RebateRatio:'返利比例',//返利比例
      MyPromoCode:'我的優惠碼：',//我的优惠码：
      MyCode:'我的優惠碼',//我的优惠码
      Copy:'複製',//复制
      CopyCode: '複製優惠碼', //复制优惠码
      MemberRebateIncome:'會員返利收益',//会员返利收益
    },
    //收益数据模块
    incomeData:{
      MemberRebateProgram:'會員返利計劃',//会员返利计划
      TextOne:'用戶通過優惠碼開通會員，您可獲得收益',//用户通过优惠码开通会员，您可获得收益
      Levels:'等級介紹',//等级介绍
      MyGrade: '我的等級：', //我的等级：
      MemberRebateIncome:'會員返利收益',//会员返利收益
      OpenMembership:'開通會員人數',//开通会员人数
      UserNickname:'用戶暱稱',//用户昵称
      OpeningTime:'開通時間',//开通时间
      RebateAmount:'返利金額',//返利金额
    },
  },
  OfflineRebate: { //下线返利模块
    InviteRegisterLink:'邀請註冊鏈接',//邀请注册链接
    IncomeData:'收益數據',//收益数据
    yuan:'元',//元
    InvitationLink:{ //邀请注册链接
      Text:'玩法說明',//玩法说明
      TextOne:'好友通過邀請鏈接註冊飛貓盤賬號後申請成爲飛貓達人，您可獲得好友收益的高額返利。',//好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的高额返利。
      TextTwo:'需通過你的邀請鏈接註冊飛貓盤賬號成功，並且申請開通成爲飛貓達人。',//需通过你的邀请链接注册飞猫盘账号成功，并且申请开通成为飞猫达人
      TextThree:'好友成爲達人後獲得飛貓盤返利收益，你就能獲得好友的收益分成。',//好友成为达人后获得飞猫盘返利收益，你就能获得好友的收益分成。
      TextFour:'邀請越多好友成爲達人，獲得更多收益分成，上不封頂。',//邀请越多好友成为达人，获得更多收益分成，上不封顶
      InviteNow:'立即邀請',//立即邀请
      CopyInvitationLink:'複製邀請鏈接',//复制邀请链接
      SavePicture:'保存圖片',//保存图片
      DownLineIncome:'下線收益',//下线收益
      Save:'保存',//保存
      TodayEarnings:'今日收益',//今日收益
      Yesterday:'昨日',//昨日
      CurrentEarnings:'本月收益',//本月收益
      SeeMore:'查看更多',//查看更多
      InvitationRecord:'邀請記錄',//邀请记录
      UserNickname:'用戶暱稱',//用户昵称
      TextFive:'是否開通CloudMaster',//是否开通飞猫达人
      InvitationTime:'邀請註冊時間',//邀请注册时间
      TextSix:'獲得99元下線返利',//获得99元下线返利
      HaveOpened:'已開通',//已开通
      HaveNotOpened:'未開通',//未开通
    },
    offIncomeData:{ //收益数据
      TodayEarnings:'今日收益',//今日收益
      YesterdayEarnings:'昨日收益',//昨日收益
      CurrentEarnings:'本月收益',//本月收益
      TextOne:'收益記錄',//收益记录
      UserNickname:'用戶暱稱',//用户昵称
      TextTwo:'返利金額（元）',//返利金额（元）
      TextThree:'爲什麼我還沒有獲得下線返利收益：',//为什么我还没有获得下线返利收益：
      TextFour:'1、檢查好友狀態：請查看邀請記錄，確認好友是否已成爲飛貓達人。',//1、检查好友状态：请查看邀请记录，确认好友是否已成为飞猫达人。
      TextFive:'2、等待收益結算：若好友已是飛貓達人，需等待他們產生收益並在次日結算後，您才能獲得返利收益分成。',//2、等待收益结算：若好友已是飞猫达人，需等待他们产生收益并在次日结算后，您才能获得返利收益分成。
    },
  },
  help: { //帮助中心模块
    FEEMOO:'Feemoo',//飞猫盘
    ShortLink:'短鏈',
    CouponCode:'優惠碼',//优惠码
    DownlineRebate:'下線返利',//下线返利
    ComplaintBox:'意見箱',//意见箱
    ContactCustomer:'聯繫客服',//联系客服
    fmp:{ //飞猫盘
      MembershipRebateModel: '會員返利模式', // 会员返利模式
      DownloadVolumeRebateModel: '下載量返利模式', // 下载量返利模式
      DownloadUserExperience: '下載用戶體驗:', // 下载用户体验
      NonMembers: '非會員：', // 非会员
      FirstDownloa: '每次首次下載免福利點（正常用戶）、後續下載需要福利點，無福利點時亦可以使用下載券或者睇影片下載方式進行下載，下載速度較慢、文件不過期。',
      FirstDownloa2: '下載不需要福利點、無下載次數限制、下載速度較慢、文件不過期、下載頁面簡潔。', // 下载不需要福利点、无下载次数限制、下载速度较慢、文件不过期、下载页面简洁。
      Members: '會員：',
      Downloadsuse: '下載消耗會員下載額度，下載速度極快。',
      Downloadsuse2: '下載不消耗會員下載額度、下載速度極快。',
      EarningsRules: '收益規則：',
      Filesreategorized: '根據文件是否大於等於 100M 区分文件屬性為大文件或小文件，根據昨日下載量評定等級和單價，按下載量返利，萬次下載最高 1888 元，並且每周三、周四雙倍享受收益（僅限下載量返利模式產生的收益）。',
      Filesreategorized2: "按用戶支付金額嘅 45% 返利。",
      Filesreategorized3: "按用戶支付金額嘅",
      Filesreategorized4: "（單筆最高100元）返利。",
      EarningsProfile:'收益簡介',//收益简介
      TextOne:'分享文件給其他用戶下載/轉存你就能獲得收益，每日所得收益次日凌晨自動結算。',//分享文件给其他用户下载/转存你就能获得收益，每日所得收益次日凌晨自动结算。
      TextTwo:'下載量返利模式：',//下载量返利模式：
      TextThree:'區分大小文件按',//区分大小文件按
      TextFour:'下載量返利',//下载量返利
      TextFive:'，區分等級萬次下載最高',//，区分等级万次下载最高
      TextSix:'1888元',//1888元
      TextSeven:'，每週三、週四',//，每周三、周四
      TextEight:'雙倍',//双倍
      TextNine:'收益。',//收益。
      TextTen:'會員返利模式：',//会员返利模式：
      TextEleven:'不按下載次數計費，只根據下載用戶開通會員進行按',//不按下载次数计费，只根据下载用户开通会员进行按
      TextTwelve:'比例分成',//比例分成
      TextThirteen:'，文件',//，文件
      TextFourteen:'不過期',//不过期
      TextFifteen:'，頁面更簡潔。',//，页面更简洁，适合
      TextSixteen:'大文件',//大文件
      TextSeventeen:'分享。',//分享。
      IncomeModelComparison:'收益模式對比',//收益模式对比
      Equity:'權益',//权益
      DownloadsRebateModel:'下載量返利模式',//下载量返利模式
      VIPRebateModel:'會員返利模式',//会员返利模式
      MoreModes:'更多模式即將上線',//更多模式即将上线
      DownloadRebateRules:'下載量返利模式規則',//下载量返利模式规则
      RebateMechanism:'1、返利機制：',//1、返利机制：
      TextEighteen:'按當日達人等級與當日所產生的下載量，在次日凌晨自動結算返利收益金額。',//按当日达人等级与当日所产生的下载量，在次日凌晨自动结算返利收益金额。
      levelRules:'2、等級規則：',//2、等级规则：
      TextNineteen:'根據昨日所產生的下載量來確定該模式下的達人返利等級，例如昨日下載量達到302，則今日達人等級爲黃金。',//根据昨日所产生的下载量来确定该模式下的达人返利等级，例如昨日下载量达到302，则今日达人等级为黄金。
      doubleRevenue:'3、雙倍收益：',//3、双倍收益：
      TextTwenty:'每週三、週四可獲得雙倍的下載量返利收益。',//每周三、周四可获得双倍的下载量返利收益。
      MemberRebateModel:'會員返利模式規則',//会员返利模式规则
      RebateMechanismTwo:'1、返利機制：',//1、返利机制：
      twentyOne:'選擇會員返利模式後，其他用戶通過你分享的下載鏈接訪問，在下載或轉存文件後，將與你建立24小時的綁定關係。 在綁定期內，若用戶在網頁端或APP端上開通會員，你將獲得其會員費用的',
      twentyTwo:'（每筆交易最高100元人民幣）作爲返利。',//作为返利。
      multiplePurchaseRebate:'2、多次購買返利：',//2、多次购买返利：
      twentyThree:'在24小時綁定期內，用戶若多次開通會員，每次開通會員金額的',//在24小时绑定期内，用户若多次开通会员，每次开通会员金额的
      twentyFour:'（每筆交易最高100元人民幣）均將作爲您的返利。',//均将作为您的返利。
      BindingRestrictions:'3、綁定關係限制：',//3、绑定关系限制：
      twentyFive:'一旦用戶與您建立了綁定關係，他們在24小時內將無法與其他達人建立新的綁定關係。',//一旦用户与您建立了绑定关系，他们在24小时内将无法与其他达人建立新的绑定关系。
      discountCode:'4、優惠碼返利限制：',//4、优惠码返利限制：
      twentySix:'當用戶使用優惠碼開通會員，您只可以獲得優惠碼返利，會員返利收益將無法疊加。',//如果用户在开通会员时使用了优惠码，平台将根据优惠码的使用情况，向你发放相应的返利收益。
    },
    discountCode:{ //优惠码
      TextOne:'什麼是優惠碼？',//什么是优惠码？
      TextTwo:'好友通過您的優惠碼開通會員享折扣，同時您可獲得高額返利；達人等級越高，優惠碼折扣越大。',//好友通过您的优惠码开通会员享折扣，同时您可获得高额返利；达人等级越高，优惠码折扣越大。
      MasterRating:'達人等級',//达人等级
    },
    rebate:{ //下线返利
      TextOne:'什麼是下線返利？',//什么是下线返利？
      TextTwo:'用戶A邀請用戶B註冊，則用戶B成爲用戶A的下線：',//用户A邀请用户B注册，则用户B成为用户A的下线：
      TextThree:'平臺按用戶B在飛貓盤推廣活動中獲得收益的15%額外給用戶A獎勵，持續有效。',//平台按用户B在飞猫盘推广活动中获得收益的15%额外给用户A奖励，持续有效。
      MasterRating:'達人等級',//达人等级
    },
    contactCust:{ //联系客服
      HotIssue:'熱門問題',//热门问题
      View:'查看',//查看
      AdditionalHelp:'其他幫助',//其他帮助
      SubmitATicket:'提交工單',//提交工单
      SubmitNow:'立即提交',//立即提交
      FeedbackHistory:'反饋歷史',//反馈历史
      ViewHistory:'進入查看',//进入查看
      TextOne:'聯繫客服',//联系客服
      TextTwo:'立即在線溝通',//立即在线沟通
      TextThree:'搵唔到問題，點呢提交問題',//没找到问题，点此提交问题
      LatestAnnouncements:'最新公告',//最新公告
      FAQ:'常見問題',//常见问题
      Back:'返回',//返回
      LoginRegister:'登入登記',//登录注册
      WithdrawEarnings:'收益提現',//收益提现
    },
  },
  IncomeReflect: { //余额提现模块
    BalanceWithdrawal:'餘額提現',//余额提现
    WithdrawalRecord:'提現記錄',//提现记录
    PayeeManagement:'收款人管理',//收款人管理
    tabZero:{ //余额提现
      withdrawableAmount:'可提現金額',//可提现金额
      Important: '重要提示：近期支付寶官方嘅收款風控規則調整，導致部分用戶無法正常收款，平台建議新增銀行卡收款人，暫時以銀行卡方式提現。',
      yuan:'元',//元
      Payee:'收款人',//收款人
      NewPayee:'新增收款人',//新增收款人
      PleaseSelect:'請選擇',//请选择
      CashWithdrawal:'提現金額',//提现金额
      TextOne:'請輸入提現金額',//请输入提现金额
      TextTwo:'每筆提現最低30元',//每笔提现最低30元
      phoneNumber:'手機號',//手机号
      PleasePhone:'請輸入手機號',//请输入手机号
      VerificationCode:'驗證碼',//验证码
      TextThree:'請輸入手機號驗證碼',//请输入手机号验证码
      TextFour:'獲取驗證碼',//获取验证码
      Sent:'已發送',//已发送
      WithdrawCashNow:'立即提現',//立即提现
      TextFive:'您尚未進行手機綁定，提現成功後將默認綁定此手機號',//您尚未进行手机绑定，提现成功后将默认绑定此手机号
      SelectAPayee:'請選擇收款人',//请选择收款人
      TextSix:'請輸入提現金額',//请输入提现金额(每笔提现最低200元)
      yuana:'元)',
      WithdrawalRules:'提現規則介紹',//提现规则介绍
      TextSeven:'1.提現次數：帳號可新增多位收款人，每位收款人每30日內最多提現9次。',//1.提现次数：账号可添加多个收款人，每个收款人每 30 天内最多可提现 9 次。
      TextEight:'2.累計額度：每位收款人每年累計提現上限為人民幣600,000元。',//2.累计限额：每个收款人每年累计提现金额最多为 60 万元人民币。
      TextNine:'3.單筆額度：單筆獨立限額為人民幣200–50,000元。',//3.单笔限额：单笔提现金额上限为 5 万元人民币。
      TextTen:'4.最低提現金額：每筆提現金額不得低於 200 元人民幣。',//4.最低提现金额：每笔提现金额不得低于 200 元人民币。
      tooltipSeven:'提現金額限制：',
      tooltipEight:'單筆獨立限額為人民幣200–50,000元。',
      tooltipNine:'中國內地銀行卡單筆獨立限額人民幣800–25,000元。',
    },
    tabOne:{ //提现记录
      OrderNumber:'訂單號',//订单号
      Amount:'金額',//金额
      Status:'狀態',//状态
      Time:'時間',//时间
      TextOne:'提現記錄爲空~',//提现记录为空~
      awaitingProcessing:'待處理',//待处理
      Successful:'成功',//成功
      Fail :'失敗',//失败
      ViewCauses :'查看原因',//查看原因
    },
    tabTwo:{ //收款人管理
      NewPayee:'新增收款人',//新增收款人
      UserNickname:'用戶暱稱',//用户昵称
      AlipayAccount:'支付寶賬號',//支付宝账号
      IdNumber:'身份證號',//身份证号
      TextOne:'當月提現額度',//当月提现额度
      Controls:'操作',//操作
      Editor:'編輯',//编辑
      Delete:'刪除',//删除
      NoRecord:'暫無記錄',//暂无记录
      PaymentMethod:'收款方式',//收款方式
      PaymentAccount:'收款賬號',//收款账号
      AnnualWithdrawalLimit:'年度可提現額度',//年度可提现额度
      MonthlyWithdrawalCount:'近30日內已提現次數',//近30天内已提现次数
    }
  },
  Account: { //账号管理模块
    TextOne:'諮詢客服了解更多',//咨询客服了解更多
    ContactCellPhone:'聯繫手機',//联系手机
    ContactEmail:'聯繫郵箱',//联系邮箱
    FEEMOOCertification:'飛貓達人認證',//飞猫达人认证
    FEEMOOCertificationTwo:'CloudMaster',//CloudMaster
    SubscriptionNumberOpening:'訂閱號開通',//订阅号开通
    CertifiedFEEMOOMaster:'已認證飛貓達人',//已认证飞猫达人
    CertifiedFEEMOOMasterTwo:'未認證CloudMaster',//未认证CloudMaster
    TextTwo:'已開通訂閱號',//已开通订阅号
    TextThree:'修改綁定手機',//修改绑定手机
    TextFour:'修改綁定郵箱',//修改绑定邮箱
    Accredited:'已認證',//已认证
    TextFive:'進入訂閱號',//进入订阅号
    BoundPhone:'綁定手機',//绑定手机
    BoundMailbox:'綁定郵箱',//绑定邮箱
    UncertifiedFEEMOO:'未認證飛貓達人',//未认证飞猫达人
    GetCertified:'去認證',//去认证
    SubscriptionNotAvailable:'未開通訂閱號',//未开通订阅号
    GoAndActivate:'去開通',//去开通
    NotActivated:'未開通',//未开通
    ActivateNow:'立即開通',//立即开通
    ActivatedNEW:'已開通',//已开通
  },
  LevelTable: { //等级表格
    ClassInterest:'等級權益',//等级权益
    DownloadsYesterday:'昨日下載量',//昨日下载量
    TextOne:'大文件返利（元/萬次）',//大文件返利（元/万次）
    TextTwo:'小文件返利（元/萬次）',//小文件返利（元/万次）
    CouponCodeDiscount:'優惠碼折扣',//优惠码折扣
    PromoCodeRevenue:'優惠碼收益',//优惠码收益
  },
  TablePublic: { //表格组件模块
    UserNickname:'用戶暱稱',//用户昵称
    OpeningTime:'開通時間',//开通时间
    RebateAmount:'返利金額',//返利金额
    NoRecord:'暫無記錄',//暂无记录
    QRCode:'二維碼',//二维码
    InvitationCode:'邀請碼',//邀请码
    InvitationLink:'邀請鏈接',//邀请链接
  },
  MemRbCom: { //会员返利收益组件
    Today:'今日',//今日
    Yesterday:'昨日',//昨日
    CurrentEarnings:'本月收益',//本月收益
    yuan:'元',//元
  },
  userNew: { // 信息悬浮框模块
    All: '全部', // 全部
    SystemNotification: '系統通知', // 系统通知
    OfficialNews: '官方消息', // 官方消息
    ReadAll: '全部已讀', // 全部已读
    Nonews: '暫無消息', // 暂无消息
  },
  exPand:{
    referralProgram:'引薦計劃',//引荐计划
    exTextOne:'什麼係引薦計劃？',//什么是引荐计划？
    exTextTwo:'引薦用戶登記Feemoo賬號成為你的下線，可以同時獲得三重獎勵：下載券、會員時長獎勵或開通會員收益分成、下線返利收益。',//引荐用户注册Feemoo账号成为你的下线可同时获得三重奖励：下载券、会员时长奖励或开通会员收益分成、下线返利收益。
    InvitationMethods:'邀請方式',//邀请方式
    exTextThree:'每個邀請鏈接都可以登記Feemoo賬號，拉新更輕鬆。換個宣傳方式，吸引更多人成為你的下線！',//每个邀请链接都能注册Feemoo账号，拉新更轻松。换个宣传方式，吸引更多人成为你的下线！
    exTextFour:'介紹Feemoo功能，吸引下線開通會員',//介绍Feemoo功能，吸引下线开通会员
    CopyInviteLink:'複製邀請鏈接',//复制邀请链接
    exTextFive:'介紹CloudMaster多種返利收益，吸引下線開通CloudMaster',//介绍CloudMaster多种返利收益，吸引下线开通CloudMaster
    exTextSix:'獎勵一：邀請登記獎勵',//奖励一：邀请注册奖励
    InviteHistory:'邀請記錄',//邀请记录
    NumberofInvitedReferrals:'已邀請下線人數',//已邀请下线人数
    ValidInvites:'有效邀請人數',//有效邀请人数
    TotalRewards:'累計獎勵',//累计奖励
    users:'人',//人
    Sheet:'張',//张
    Days:'天',//天
    money:'元',//元
    ci:'次',//次
    exTextSeven:'·註冊Feemoo賬號並綁定手機號在次日登陸APP或桌面客戶端後視為有效邀請',//·注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后视为有效邀请
    exTextEight:'·同一部設備、同一個賬號僅會被計算為被邀請嘅新下線用戶一次，Feemoo官方會過濾異常數據。',//·同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。
    exTextNine:'每次有效邀請獎勵5張下載券，最多累計可獲得50位新用戶邀請獎勵。',//每次有效邀請獎勵5張下載券，最多累計可獲得50位新用戶邀請獎勵。
    exTextTen:'可得50位新用戶邀請獎勵。',//获得50位新用户邀请奖励。
    exTextEleven:'獎勵二：下線開通會員',//奖励二：下线开通会员
    CurrentRewards:'當前獎勵方式：',//当前奖励方式：
    Membershipduration:'會員時長獎勵',//会员时长奖励
    ActivationAmount:'開通金額獎勵',//开通金额奖励
    PendingRewards:'待處理獎勵',//待处理奖励
    ReceivedRewards:'已到賬獎勵',//已到账奖励
    TotalRewards:'累計獎勵',//累计奖励
    EarningsRecords:'收益記錄',//收益记录
    TodayEarnings:"今日收益",//今日收益
    YesterdayEarnings:"昨日收益",//昨日收益
    TotalEarnings:'累計收益',//累计收益
    exTextTwelve:'獎勵三：下線返利',//奖励三：下线返利
    Rules:'規則說明',//规则说明
    RewardRules:'獎勵規則',//奖励规则
    RewardOne:'獎勵一：',//奖励一：
    exTextThirteen:'透過您鏈接邀請嘅第一位新用戶登記Feemoo賬號並綁定手機號在次日登陸APP或桌面客戶端後，首次邀請您可獲得3天體驗會員時長，後續您每邀請1位可獲得1天體驗會員時長。',//通过您链接邀请的第一位新用户注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，首次邀请您可获得3天体验会员时长，后续您每邀请1位可获得1天体验会员时长
    RewardTwo:'獎勵二：',//奖励二：
    exTextFourteen:'透過您鏈接邀請嘅新用戶登記Feemoo賬號登陸後，將成為你的下線，其喺3個月（90天）內每次成功購買Feemoo會員，您可揀按會員時長獎勵或實付金額嘅20%獲得獎勵。',//通过您链接邀请的新用户注册Feemoo账号登录后，将成为你的下线，其在3个月（90天）内每次成功购买Feemoo会员，您可选择按会员时长奖励或实付金额的20%获得奖励。
    exTextFifteen:'例如：若您嘅下線3個月內購買4次月度會員，您將獲贈24天月度會員時長或24元返利收益；若其購買不限時長會員，您將獲贈77.6天體驗會員時長或77.6元返利收益。',//例如：若您的下线3个月内购买4次月度会员，您将获赠24天月度会员时长或24元返利收益；若其购买不限时长会员，您将获赠77.6天体验会员时长或77.6元返利收益。
    RewardThree:'獎勵三：',//奖励三：
    exTextSixteen:'透過您鏈接邀請嘅新用戶登記Feemoo賬號登陸後，成功開通CloudMaster並完成Feemoo返利收益結算，您即可獲得該下線用戶收益嘅15%分成。',//通过您链接邀请的新用户注册Feemoo账号登录后，成功开通CloudMaster并完成Feemoo返利收益结算，您即可获得该下线用户收益的15%分成。
    ExpandDownstreamMode:'擴充下線模式：',//扩充下线模式：
    exTextSeventeen:'除專屬邀請鏈接外，您亦可透過擴充下線模式嘅文件鏈接分享畀其他人登記來擴充更多下線。',//除专属邀请链接外，您也可通过扩充下线模式的文件链接分享给其他人注册来扩充更多下线。
    AssessmentCriteria:'判定細則',//判定细则
    exTextEighteen:'下線用戶購買會員嘅開通獎勵會喺 30 分鐘內發放到待處理收',//下线用户购买会员的开通奖励会在 30 分钟内发放到待处理收
    exTextNineteen:'益，符合條件嘅分成獎勵需等待 7 天後先可到賬提现，',//益，符合条件的分成奖励需等待7天后才可到账提现，
    exTextTwenty:'特殊情況可能會延遲。',//特殊情况可能会延迟。
    exTextTwentyOne:'新用戶需透過您的專屬邀請鏈接登記Feemoo賬號並綁定手機號在次日登陸APP或桌面客戶端後，先視為有效邀請。',//新用户需通过您的专属邀请链接注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，才视为有效邀请。
    exTextTwentyTwo:'您作為上線用戶，邀請下線用戶嘅新用戶登記獎勵，僅限前50位有效邀請。超出後，上線用戶不再获此獎勵，但購買會員嘅分成獎勵與下線返利無次數、人數限制，上不封頂。',//您作为上线用户，邀请下线用户的新用户注册奖励，仅限前50位有效邀请。超出后，上线用户不再获此奖励，但购买会员的分成奖励与下线返利无次数、人数限制，上不封顶。
    exTextTwentyThree:'獎勵一嘅統計數據起始時間為2025年5月30日，您喺該時間之前邀請嘅新用戶無法獲得該獎勵。',//奖励一的统计数据起始时间为2025年5月30日，您在该时间之前邀请的新用户无法获得该奖励。
    exTextTwentyFour:'下線用戶自登記起3個月（90天）內，透過官方渠道會員訂閱或APP內購開通會員，視為成功購買會員。而透過免費兌換、獎勵等獲得嘅免費會員資格，不視為購買會員。',//下线用户自注册起3个月（90天）内，通过官方渠道会员订阅或APP内购开通会员，视为成功购买会员。而通过免费兑换、奖励等获得的免费会员资格，不视为购买会员。
    exTextTwentyFive:'透過您嘅邀請鏈接登記賬號嘅下線用戶，如果用戶使用優惠碼開通會員，您只能獲得優惠碼返利，獎勵二將無法疊加。',//通过您的邀请链接注册账号的下线用户，如果用户使用优惠码开通会员，您只能获得优惠码返利，奖励二将无法叠加。
    exTextTwentySix:'透過您嘅邀請鏈接登記賬號嘅下線用戶，如果下載會員返利模式文件並喺24小時內開通會員，你只能獲得會員返利模式收益，獎勵二無法疊加。',//通过您的邀请链接注册账号的下线用户，如果下载会员返利模式文件并在24小时内开通会员，你只能获得会员返利模式收益，奖励二无法叠加。
    exTextTwentySeven:'獎勵二嘅統計數據起始時間2025年5月30日，近3個月（90 天）內您邀請嘅下線用戶喺2025年5月30日後開通會員，您仍可獲得該獎勵。',//奖励二的统计数据起始时间为2025年5月30日，近3个月（90天）内您邀请的下线用户在2025年5月30日后开通会员，您仍可获得该奖励。
    exTextTwentyEight:'您喺2025年5月30日之前邀請嘅下線用戶仍可獲得該獎勵。',//您在2025年5月30日之前邀请的下线用户仍可获得该奖励。
    OtherNotes:'其他說明',//其他说明
    exTextTwentyNine:'邀請獎勵與下線返利將喺48小時內發放到當前用戶賬號；下線用戶購買會員嘅開通獎勵會喺30分鐘內發放到待處理獎勵，符合條件嘅分成獎勵需等待7天後先可以到賬提现，特殊情況可能會延遲。',//邀请奖励与下线返利将在48小时内发放至当前用户账号；下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
    exTextThirty:'透过獎勵所獲得嘅體驗會員時長，將自動發放到當前用戶賬號，具體發放時間請查看系統通知。',//通过奖励所获得的体验会员时长，将自动发放到当前用户账号，具体发放时间请查看系统通知。
    exTextThirtyOne:'透過獎勵所獲得嘅體驗會員時長，無法透過補差價升級為不限時長會員。',//通过奖励所获得的体验会员时长，无法通过补差价升级为不限时长会员。
    exTextThirtyTwo:'同一部設備、同一個賬號僅會被計算為被邀請嘅新下線用戶一次，Feemoo官方會過濾異常數據。',//同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo官方会过滤异常数据。
    exTextThirtyThree:'對於違規行為（包括但不限於惡意刷量、違規折現、模擬用戶行為等），Feemoo官方有權取消參與者嘅活動資格，並採取收回獎勵、封禁賬號等措施。如有異議，可透过幫助中心提交問題申訴。',//对于违规行为（包括但不限于恶意刷量、违规折现、模拟用户行为等），Feemoo官方有权取消参与者的活动资格，并采取收回奖励、封禁账号等措施。如有异议，可通过帮助中心提交问题申诉。
    exTextThirtyFour:'為更準確識別惡意刷量，部分低版本APP登記用戶將無法獲得引薦計劃活動獎勵。',//为更准确识别恶意刷量，部分低版本 APP 注册用户将无法获得引荐计划活动奖励。
    exTextThirtyFive:'如果我們已向您發放咗收益，但您或您的下線用戶違反咗我哋嘅用戶協議或規則，則我哋會保留從應向您發放嘅未來收益中扣除已支付收益嘅權利。',//如果我们已向您发放了收益，但您或您的下线用户违反了我们的用户协议或规则，则我们会保留从应向您发放的未来收益中扣除已支付收益的权利。
    exTextThirtySix:'此活動僅限Feemoo用戶參加，最終解釋權歸Feemoo官方所有。',//此活动仅限Feemoo用户参加，最终解释权归Feemoo官方所有。
    HeadTo:'前往',//前往
    exTextThirtySeven:'創建分享選擇下載量返利模式',//创建分享选择下载量返利模式
    exTextThirtyEight:'其他用戶透过分享鏈接下載文件成功',//其他用户通过分享链接
    exTextThirtyNine:'根據文件大小同下載量返利',//下载文件成功
    exTextForty:'每周三、周四收益翻倍！',//每周三、周四双倍收益！
    exTextFortyOne:'其他用戶透過分享鏈接下載文件成功後建立綁定關係',//其他用户通过分享链接下载文件成功后建立绑定关系
    exTextFortyTwo:'已有綁定關係嘅用戶24小時內開通會員',//已有绑定关系的用户24小时内开通会员
    exTextFortyThree:'你獲得綁定關係用戶開通會員嘅分成收益',//你获得绑定关系用户
    ExpandReferralsMode:'擴充下線模式',//扩充下线模式
    exTextFortyFour:'透過分享鏈接登記成為新用戶後建立下線關係',//通过分享链接注册成为新用户后建立下线关系
    exTextFortyFive:'更多嘅下線讓你喺',//更多的下线让你
    exTextFortySix:'引薦計劃',//引荐计划
    exTextFortySeven:'中獲得更多收益',//中获得更多收益
    exTextFortyEight:'今日新增下線人數',//今日新增下线人数
    exTextFortyNine:'累計下線人數',//累计下线人数
    exTextFifty:'創建分享選擇會員返利模式',//创建分享选择会员返利模式
    exTextFiftyOne:'創建分享選擇擴充下線模式',//创建分享选择扩充下线模式
    exTextFiftyTwo:'前往引薦計劃',//前往引荐计划
    exTextFiftyThree:'去查看',//去查看
    exTextFiftyFour:'新增下線人數',//去查看
    exTextFiftyFive:'通過你分享嘅文件鏈接登記FEEMOO賬號，新用戶將成為你的下線',//通过你分享的文件链接注册Feemoo账号，新用户将成为你的下线
    exTextFiftySix:'下下線用戶購買會員的開通獎勵會喺30分鐘內發放到待處理獎勵，符合條款的分成獎勵需等待7天後先可以到賬提现，特殊情況可能會延遲。',//下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
  },
}
